// extracted by mini-css-extract-plugin
module.exports = {"block_heading":"HeadingTextStyle_block_heading__1Sa6m"};